export default __webpack_public_path__ + "static/media/virat.d54b5cea.png";